import "../../css/pages/solution.scss";
//import sectionNav from "../modules/sectionNav";
//import sectionNavV2 from "../modules/sectionNavV2";

import BasePage from "./base";
import { setScrollLink } from "../modules/scrollTo";

class SolutionPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    onReady() {
        super.onReady();
        this.scrollLinks();
        this.topBtn();
        //this.burger();
        //sectionNav.init();
        //sectionNavV2.init();
        setScrollLink(".heroLink--anchor");
    }
    scrollLinks() {
        let elements = document.querySelectorAll("[data-scroll]");
        Array.prototype.forEach.call(elements, function(link) {
            link.addEventListener("click", function(e) {
                e.preventDefault();

                let linkValue = link.getAttribute("data-scroll");
                linkValue = linkValue.replace("#", "");
                let anchor = document.getElementById(linkValue);
                if (anchor) {
                    let headerHeight = document.querySelector("header").offsetHeight;
                    let elementPosition = anchor.getBoundingClientRect().top;
                    let offsetPosition = elementPosition - headerHeight - 150;

                    window.scrollBy({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            });
        });
    }
    topBtn() {
        let btn = document.querySelector(".top-btn");
        window.addEventListener("scroll", function() {
            let scrollVal = this.scrollY;
            if (scrollVal >= 600) {
                btn.classList.add("visible");
            }
            if (scrollVal < 600) {
                btn.classList.remove("visible");
            }
        });
    }
    burger() {
        let burgerBtn = document.querySelector(".burger");
        burgerBtn.addEventListener("click", function() {
            this.classList.toggle("active");
        });
    }
}

new SolutionPage();
